import { Link } from "react-router-dom";
import { Github, Linkedin } from "lucide-react";
import { BrandLogo } from "@/components/shared/BrandLogo";
import { visiblePillars } from "@/data/automacaoServices";
import { services } from "@/data/services";

const columns = [
  {
    title: "Serviços",
    links: services.map((s) => ({ label: s.shortTitle, href: s.href })),
  },
  {
    title: "Automação",
    // TEMP: pilar Odoo sai via `visiblePillars` — ver docs/specs/temporary-changes.md
    links: visiblePillars.map((p) => ({
      label: p.tag,
      href: `/automacao-empresarial/${p.slug}`,
    })),
  },
  {
    title: "Navegar",
    links: [
      { label: "Produtos", href: "/produtos" },
      { label: "Cases", href: "/projetos" },
      { label: "Blog", href: "/blog" },
      { label: "Sobre", href: "/sobre" },
      { label: "Contato", href: "/contato" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Política de privacidade", href: "/politica-de-privacidade" },
      { label: "Termos de uso", href: "/termos-de-uso" },
    ],
  },
];

const FooterNew = () => (
  <footer className="border-t border-border bg-card">
    <div className="mx-auto grid max-w-[1180px] grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-[34px] px-8 pb-[46px] pt-[46px] max-[900px]:px-5">
      <div>
        <BrandLogo className="h-7" />
        <p className="mt-3.5 max-w-[250px] text-[13px] leading-[1.65] text-muted-foreground">
          Sites, sistemas e automação com IA para pequenas e médias empresas.
        </p>
        <div className="mt-4 flex gap-2">
          <a
            href="https://github.com/eliveutonsouza"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-border text-muted-foreground transition-colors hover:text-foreground"
          >
            <Github className="h-4 w-4" />
          </a>
          <a
            href="https://www.linkedin.com/in/eliveuton-souza/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-border text-muted-foreground transition-colors hover:text-foreground"
          >
            <Linkedin className="h-4 w-4" />
          </a>
        </div>
      </div>

      {columns.map((col) => (
        <div key={col.title}>
          <div className="text-[11.5px] font-bold uppercase tracking-[0.07em] text-muted-foreground">
            {col.title}
          </div>
          <div className="mt-3.5 flex flex-col gap-[9px] text-[13.5px]">
            {col.links.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                className="w-fit text-muted-foreground transition-colors hover:text-foreground"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
    <div className="mx-auto max-w-[1180px] px-8 pb-[34px] text-xs text-muted-foreground max-[900px]:px-5">
      © {new Date().getFullYear()} Eliveuton Souza
    </div>
  </footer>
);

export default FooterNew;
